import styled from 'styled-components'

/*----- Commons -----*/
import Device from '../../commons/Device'

export default styled.main`
	padding: 180px 0 180px 0;
	display: flex;
	justify-content: center;
	flex-direction: column;
	.circle-container {
    overflow: hidden;
    height: 600px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
		.circle-container__blue-circle {
			width: 1000px;
			top: -500px;
			position: absolute;
			opacity: 0.2;
		}
	}
	.our-home__logo {
		width: 320px;
	}
	.our-home-wellcome {
		video {
			opacity: 0.6;
		}
		.video-container {
			width: 100% !important;
		}
	}
	.quote-card-container {
		margin: 64px 0;
	}
	.our-home-item {
		padding: 0 16px;
	}

	@media ${ Device.lg } {
		.our-home-wellcome {
			.video-container {
				border-radius: 50%;
				width: 400px !important;
			}
		}
	}
	
`